// Types

export const VExpansionPanelSymbol = Symbol.for('vuetify:v-expansion-panel');
//# sourceMappingURL=shared.js.map